const publishProgressLabels: Record<number, string> = {
  7: 'Pubblicazione...',
  8: 'Sincronizzazione dati...',
};

export const getPublishProgressLabel = (publishStep: number) => publishProgressLabels[publishStep] ?? null;
